import { Base64 } from "js-base64";

export const validUrl = (url: string): string => {
  if (!url) {
    return "";
  }
  try {
    new URL(url);
    return "";
  } catch {
    return "Must input a valid URL!";
  }
};

export const validHttpUrl = (str: string): string => {
  try {
    new URL(str);
    if (str.startsWith("https://") || str.startsWith("http://")) {
      return "";
    } else {
      return "Only http and https protocol URLs are supported!";
    }
  } catch {
    return "Must input a valid URL!";
  }
};

export const validToUrl = (str: string): string => {
  try {
    new URL(str);
    if (
      str.startsWith("https://") ||
      str.startsWith("https+unix://") ||
      str.startsWith("http://") ||
      str.startsWith("http+unix://") ||
      str.startsWith("ssh://") ||
      str.startsWith("tcp://") ||
      str.startsWith("udp://")
    ) {
      return "";
    } else {
      return "Only ssh, tcp, udp, http, http+unix, https, and https+unix protocol URLs are supported!";
    }
  } catch {
    return "Must input a valid URL!";
  }
};

export const validateK8sServiceAccountToken = (str: string): string => {
  if (!str) {
    return "";
  }
  const sections = str.split(".");
  if (sections.length !== 3 || !sections.every(Base64.isValid)) {
    return "Must input a valid JWT!";
  }
  const payload = JSON.parse(Base64.decode(sections[1]));
  if (!payload || payload.iss !== "kubernetes/serviceaccount") {
    return "Not a Kubernetes Service Account token";
  }
  return "";
};
